export default {
  getAvailableClass: `/member/class/all`,
  registerClass: `/member/class`,
};
